<template>
  <div>
    <b-tabs>
      <b-tab
        title="Stüdyo İçeriği"
        active
      >
        <video-embed />
        <b-card>
          <content-text />
        </b-card>
        <photo-gallery />
      </b-tab>
      <b-tab title="Stüdyo Videoları">
        <studio-videos />
      </b-tab>
      <b-tab title="Stüdyo Ekipman Listesi">
        <studio-equipment />
      </b-tab>
    </b-tabs>
    <b-button
      variant="primary"
      :disabled="!itemData.video_embed || itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
    <!-- :disabled="!itemData.video_embed || itemData.submitStatus" -->
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton, BTabs, BTab,
} from 'bootstrap-vue'

import PhotoGallery from '@/views/Admin/Studio/elements/PhotoGallery.vue'
import VideoEmbed from '@/views/Admin/Studio/elements/VideoEmbed.vue'
import ContentText from '@/views/Admin/Studio/elements/Content.vue'
import StudioVideos from '@/views/Admin/Studio/elements/StudioVideos.vue'
import StudioEquipment from '@/views/Admin/Studio/elements/StudioEquipment.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    PhotoGallery,
    ContentText,
    VideoEmbed,
    StudioVideos,
    StudioEquipment,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['studio/dataItem']
    },
  },
}
/* <pre>{{
      itemData}}
    </pre> ile verinin dolup dolmadığını anlarım! */
</script>
